import { track } from '@vercel/analytics';

// Custom event tracking for key user actions
export const trackEvent = {
  // Authentication events
  signUp: (method: string = 'email') => {
    track('sign_up', { method });
  },

  signIn: (method: string = 'email') => {
    track('sign_in', { method });
  },

  signOut: () => {
    track('sign_out');
  },

  // Age verification events
  ageVerified: (age: number, state?: string) => {
    track('age_verified', {
      ageGroup: age >= 18 ? '18+' : age >= 14 ? '14-17' : 'under-14',
      ...(state && { state }),
    });
  },

  parentalConsentRequired: () => {
    track('parental_consent_required');
  },

  // School selection events
  schoolViewed: (schoolId: string, schoolName: string) => {
    track('school_viewed', { schoolId, schoolName });
  },

  schoolAdded: (schoolId: string, schoolName: string) => {
    track('school_added_to_list', { schoolId, schoolName });
  },

  schoolRemoved: (schoolId: string, schoolName: string) => {
    track('school_removed_from_list', { schoolId, schoolName });
  },

  // Profile events
  profileCompleted: (completionPercentage: number) => {
    track('profile_completed', { completionPercentage });
  },

  profileUpdated: (section: string) => {
    track('profile_updated', { section });
  },

  // Navigation events
  pageView: (pageName: string) => {
    track('page_view', { page: pageName });
  },

  // Conversion events
  subscriptionStarted: (plan: string, price: number) => {
    track('subscription_started', { plan, price });
  },

  // Error events (supplement Sentry)
  errorOccurred: (errorType: string, context?: string) => {
    track('error_occurred', { errorType, ...(context && { context }) });
  },
};
